













import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'UCButton',
  props: {
    outline: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    blank: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes(): any {
      return [
        this.outline ? 'outline' : null,
        this.inline ? 'inline' : null,
        this.blank ? 'blank' : null,
        this.compact ? 'compact' : null,
      ]
        .filter(Boolean)
        .join(' ');
    },
    component(): any {
      return this.href ? 'nuxt-link' : 'button';
    },
  },
});
